"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _PctyQuestion = _interopRequireDefault(require("./PctyQuestion.Checkbox"));
var _PctyQuestion2 = _interopRequireDefault(require("./PctyQuestion.MultiLine"));
var _PctyQuestion3 = _interopRequireDefault(require("./PctyQuestion.MultipleChoice"));
var _PctyQuestion4 = _interopRequireDefault(require("./PctyQuestion.SectionParagraph"));
var _PctyQuestion5 = _interopRequireDefault(require("./PctyQuestion.SectionTitle"));
var _PctyQuestion6 = _interopRequireDefault(require("./PctyQuestion.SingleLine"));
var _PctyQuestion7 = _interopRequireDefault(require("./PctyQuestion.StackRank"));
var _PctyQuestion8 = _interopRequireDefault(require("./PctyQuestion.StarRating"));
var _PctyQuestion9 = _interopRequireDefault(require("./PctyQuestion.RatingScale"));
var _PctyQuestion10 = _interopRequireDefault(require("./PctyQuestion.MultipleText"));
var _PctyQuestionConstantSum = _interopRequireDefault(require("./PctyQuestion.ConstantSum.js"));
var _PctyQuestionDropdownList = _interopRequireDefault(require("./PctyQuestion.DropdownList.js"));
var _PctyQuestionVideo = _interopRequireDefault(require("./PctyQuestion.Video.js"));
var _default = exports.default = {
  Checkbox: _PctyQuestion.default,
  MultiLine: _PctyQuestion2.default,
  MultipleChoice: _PctyQuestion3.default,
  SectionParagraph: _PctyQuestion4.default,
  SectionTitle: _PctyQuestion5.default,
  SingleLine: _PctyQuestion6.default,
  StackRank: _PctyQuestion7.default,
  StarRating: _PctyQuestion8.default,
  RatingScale: _PctyQuestion9.default,
  MultipleText: _PctyQuestion10.default,
  ConstantSum: _PctyQuestionConstantSum.default,
  DropdownList: _PctyQuestionDropdownList.default,
  Video: _PctyQuestionVideo.default
};